import React, { Component } from "react";
import GoogleAnalytics from "react-ga";
import jwt_decode from "jwt-decode";

let productionAnalyticKey = "UA-115403135-2";
let devAnalyticKey = 'UA-XXXXX-Y';
GoogleAnalytics.initialize(productionAnalyticKey, {
  debug: false
});

/**
 * FOR DEVELOPMENT ENVIRONMENT
 */
//GoogleAnalytics.set({ 'sendHitTask': null });


const WithTracker = (WrappedComponent, _AUTH , options = {}) => {
  try {
    let token = localStorage.getItem("token");

    if (token) {
      let parsedToken = jwt_decode(token);
      let uniqueId = parsedToken.unique_id;
      GoogleAnalytics.set({ userId: uniqueId });
    }
  } catch (err) {
    // console.log(err);
  }

  const trackPage = page => {
    GoogleAnalytics.set({
      page,
      ...options
    });
    GoogleAnalytics.pageview(page);
  };

  const HOC = class extends Component {
    componentDidMount() {
      const page = this.props.location.pathname;
      trackPage(page);
    }

    componentWillReceiveProps(nextProps) {
      const currentPage = this.props.location.pathname;
      const nextPage = nextProps.location.pathname;

      if (currentPage !== nextPage) {
        trackPage(nextPage);
      }
    }

    render() {
      return (
        <WrappedComponent {...this.props} _AUTH={_AUTH}  GoogleAnalytics={GoogleAnalytics} />
      );
    }
  };

  return HOC;
};

export default WithTracker;
